import { render, staticRenderFns } from "./printsavings.vue?vue&type=template&id=46945907"
import script from "./printsavings.vue?vue&type=script&lang=js"
export * from "./printsavings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports